import { logUsage } from 'owa-analytics';
import { PremiumPreviewStatus } from '../../store/schema/PremiumPreviewData';
import { assertNever } from 'owa-assert';

// open basic skittle (no premium preview)
export const DP_OPEN_UPSELL_CALLOUT = 'EditorProofing_SkittleOpenUpsellCallout';

// open skittle while the status is activated
export const DP_OPEN_SKITTLE_ACTIVATED = 'EditorProofing_PremiumPreview_CountdownCalloutOpen';

// open skittle while status is expired
export const DP_OPEN_SKITTLE_EXPIRED = 'EditorProofing_PremiumPreview_EndCalloutOpen';

// Trigger Premium preview from Skittle
export const DP_OPEN_PREMIUM_PREVIEW_FROM_SKITTLE =
    'EditorProofing_SkittleOpenPremiumPreviewOptInDialog';

export function logOnSkittleClicked(premiumPreviewStatus: PremiumPreviewStatus) {
    let dataPointName: string;
    switch (premiumPreviewStatus) {
        case PremiumPreviewStatus.Activated:
            dataPointName = DP_OPEN_SKITTLE_ACTIVATED;
            break;
        case PremiumPreviewStatus.Expired:
            dataPointName = DP_OPEN_SKITTLE_EXPIRED;
            break;
        case PremiumPreviewStatus.Unknown:
            dataPointName = DP_OPEN_UPSELL_CALLOUT;
            break;
        // when status is new, it means the premium preview was triggerd, and we already logging that
        case PremiumPreviewStatus.New:
            dataPointName = DP_OPEN_PREMIUM_PREVIEW_FROM_SKITTLE;
            break;
        default:
            assertNever(premiumPreviewStatus);
    }
    dataPointName && logUsage(dataPointName, {}, { isCore: true });
}
